// extracted by mini-css-extract-plugin
export default {"r_l":"df50cbd373 _8a11dfcd7f","t":"_76e5c01d40"};